import { render, staticRenderFns } from "./CreateOrganizationByLink.vue?vue&type=template&id=4dc8d670&scoped=true&"
import script from "./CreateOrganizationByLink.vue?vue&type=script&lang=js&"
export * from "./CreateOrganizationByLink.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrganizationByLink.vue?vue&type=style&index=0&id=4dc8d670&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc8d670",
  null
  
)

export default component.exports